import vars from './vars';
import router from './router';

let similarArray = [];

vars.$article.each((index, element) => {
	let $this = $(element);

	similarArray[index] = {
		title: $this.find('.article__title').text(),
		text: $this.find('.article__title__sub').text(),
		img: `/images/article/preview-${index + 1}.jpg`,
		url: `/article/${$this.data('article')}`,
	};
});

export default {
	article(notThis) {
		let uniqueRandoms = [];
		let numRandoms = vars.$article.length - 1;
		let tl = '';

		function makeUniqueRandom() {
			if (!uniqueRandoms.length) {
				for (let i = 0; i < numRandoms; i++) {
					if (i !== notThis) {
						uniqueRandoms.push(i);
					}
				}
			}

			let index = Math.floor(Math.random() * uniqueRandoms.length);
			let val = uniqueRandoms[index];

			uniqueRandoms.splice(index, 1);

			return val;
		}

		for (let i = 0; i < 3; i++) {
			let id = makeUniqueRandom();

			tl += `<a class="article__similar__item" href="${similarArray[id].url}" data-router-link="">`;
			tl += `<div class="article__similar__image" style="background-image:url(${similarArray[id].img})"></div>`;
			tl += `<div class="article__similar__title">${similarArray[id].title}</div>`;
			tl += `<div class="article__similar__text">${similarArray[id].text}</div></a>`;
		}

		vars.$similar.html(tl);
		router.bindLinks();
	},
};
